// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const ChartLineUpSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M2 21V2H3V21H22V22H3C2.44772 22 2 21.5523 2 21ZM20.4277 6.2589L14.8237 15.5178C14.6425 15.8171 14.3181 16 13.9682 16H12.9842C12.6874 16 12.406 15.8682 12.216 15.6402L10.0158 13H8.98419L5.38411 17.3201L4.61589 16.6799L8.21597 12.3598C8.40596 12.1318 8.68741 12 8.98419 12H10.0158C10.3126 12 10.594 12.1318 10.784 12.3598L12.9842 15H13.9682L19.5723 5.7411L20.4277 6.2589Z" />
    </svg>
  )
}
